module.exports = __webpack_public_path__ + "static/media/generateur.17346fb4.jpg";